import {
  AccordionGroup,
  BLOTTER_TABLE_FILTERS_CONTAINER_ID,
  Box,
  MixpanelEvent,
  Tab,
  TabList,
  TabPanels,
  TabSize,
  Tabs,
  tabLabelerEnumerated,
  useMixpanel,
  usePersistedTabs,
  usePortal,
  useTabs,
} from '@talos/kyoko';
import { useCallback } from 'react';
import { CounterpartyMonitoringBlotterTable } from './CounterpartyMonitoringBlotterTable';

const counterpartyMonitoringBlotterId = 'operations/operational-risk/counterparty-monitoring';
const tabLabeler = tabLabelerEnumerated('Counterparty Monitoring');

export function CounterpartyMonitoring() {
  const mixpanel = useMixpanel();
  const handleAdd = useCallback(() => {
    mixpanel.track(MixpanelEvent.AddTab);
  }, [mixpanel]);
  const persistedTabs = usePersistedTabs(counterpartyMonitoringBlotterId, {
    defaultInitialItems: [
      {
        id: 'all-counterparties',
        label: 'All Counterparties',
        closable: false,
        editable: false,
      },
    ],
    defaultInitialSelectedIndex: 0,
  });
  const tabs = useTabs({
    ...persistedTabs,
    showAddTab: true,
    tabLabeler,
    onAdd: handleAdd,
  });
  const { setPortalRef: filtersContainerRef } = usePortal(BLOTTER_TABLE_FILTERS_CONTAINER_ID);

  return (
    <Tabs {...tabs} h="100%" size={TabSize.Large}>
      <TabList isBordered background="backgroundContent" rightItems={<Box ref={filtersContainerRef} />}>
        {tabs.items.map(tab => (
          <Tab key={tab.id} {...tab} />
        ))}
      </TabList>
      <TabPanels style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
        {tabs.items.map(tab => (
          <AccordionGroup key={tab.id}>
            <CounterpartyMonitoringBlotterTable
              blotterID={`${counterpartyMonitoringBlotterId}/${tab.id}`}
              tabLabel={tab.label}
            />
          </AccordionGroup>
        ))}
      </TabPanels>
    </Tabs>
  );
}
